// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"ErrorBoundary_errorMessage__39UgJ"};